import { createFileRoute } from '@tanstack/react-router'
import { NetworkDashboardPage } from '~/components/routes/network-dashboard/page/network-dashboard-page'
import { withRoutePermissions } from '~/utils/rbac'
import { networkDashboardSearchSchema } from './search-schema'

function NetworkDashboardRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return <NetworkDashboardPage search={search} navigate={navigate} />
}

export const Route = createFileRoute('/_authenticated/network-dashboard/')({
  component: NetworkDashboardRoute,
  staticData: { permission: ['read', 'network.network.network-dashboard'] },
  validateSearch: networkDashboardSearchSchema,
})

withRoutePermissions(Route)
